class ErrorHelperStatic {
    ifUserError(error: any, ifUserErrorCallback: ((userError: string) => void)): boolean {
        const errorMessage = error?.response?.data?.message
        if (errorMessage && (typeof(errorMessage == 'string' || errorMessage instanceof String))) {
            const userMessage = errorMessage.match("^UserMessage=(.+)$")
            if (userMessage && userMessage.length == 2) {
                ifUserErrorCallback(userMessage[ 1 ])
                return true
            }
        }
        return false
    }
}
const ErrorHelper = new ErrorHelperStatic()
export default ErrorHelper